import { combineUrlAndPath } from "@scalar/helpers/url/merge-urls";
function getServersFromDocument(servers, options = {}) {
  if (!servers?.length) {
    const fallbackServer = createFallbackServer(options);
    return fallbackServer ? [fallbackServer] : [];
  }
  if (!Array.isArray(servers)) {
    return [];
  }
  const validServers = servers.map((server) => processServerObject(server, options));
  if (validServers.length === 0) {
    const fallbackServer = createFallbackServer(options);
    return fallbackServer ? [fallbackServer] : [];
  }
  return validServers;
}
function extractBaseUrlFromDocumentUrl(documentUrl) {
  try {
    const url = new URL(documentUrl);
    const port = url.port ? `:${url.port}` : "";
    return `${url.protocol}//${url.hostname}${port}`;
  } catch {
    return void 0;
  }
}
function getFallbackUrl() {
  if (typeof window === "undefined" || typeof window?.location?.origin !== "string") {
    return void 0;
  }
  return window.location.origin;
}
function createServerFromUrl(url) {
  return { url };
}
function createDefaultServerFromDocumentUrl(documentUrl) {
  const baseUrl = extractBaseUrlFromDocumentUrl(documentUrl);
  if (!baseUrl) {
    return void 0;
  }
  return createServerFromUrl(baseUrl);
}
function createDefaultServerFromFallback() {
  const fallbackUrl = getFallbackUrl();
  if (!fallbackUrl) {
    return void 0;
  }
  return createServerFromUrl(fallbackUrl);
}
function resolveRelativeServerUrl(serverUrl, options) {
  const { baseServerUrl: baseServerURL, documentUrl } = options;
  if (baseServerURL) {
    return combineUrlAndPath(baseServerURL, serverUrl);
  }
  if (documentUrl) {
    const baseUrl = extractBaseUrlFromDocumentUrl(documentUrl);
    if (baseUrl) {
      return combineUrlAndPath(baseUrl, serverUrl);
    }
  }
  const fallbackUrl = getFallbackUrl();
  if (fallbackUrl) {
    return combineUrlAndPath(fallbackUrl, serverUrl);
  }
  return serverUrl;
}
function processServerObject(server, options) {
  if (server.url?.startsWith("/")) {
    server.url = resolveRelativeServerUrl(server.url, options);
  }
  return server;
}
function createFallbackServer(options) {
  if (options.documentUrl) {
    const defaultServer = createDefaultServerFromDocumentUrl(options.documentUrl);
    if (defaultServer) {
      return defaultServer;
    }
  }
  return createDefaultServerFromFallback();
}
export {
  getServersFromDocument
};
//# sourceMappingURL=server.js.map
